<template>
  <McPagination
    :currentPage="currentPage"
    :totalRows="totalRows"
    :perPage="perPage"
    :pageOptions="pageOptions"
    :fields="fields"
    :filteredItems="filteredItems"
    :rows="rows"
    @currentPagePage="currentPageValue"
    @newPerPage="perPageValue"
  />
</template>

<script>
import McPagination from './index.vue'
export default {
  components: {
    McPagination,
  },
  props: {
    fields: {
      type: Array,
    },
    filteredItems: {
      type: Array,
    },
  },

  data() {
    return {
      perPage: 5,
      pageOptions: [5, 10, 15, 20],
      totalRows: this.filteredItems.length,
      currentPage: 1,
    }
  },

  computed: {
    rows() {
      return this.filteredItems.length
    },
  },

  methods: {
    currentPageValue(value) {
      this.currentPage = value
    },

    perPageValue(value) {
      this.currentPage = 1
      this.perPage = value
    },
  },
}
</script>
